import { Form, Field } from "formik";
import {
  Button,
  Col,
  FormGroup,
  InputGroup,
  InputGroupText,
  Label,
  Row,
} from "reactstrap";
import { BiRupee } from "react-icons/bi";
import styles from "./AddApplicantForm.module.scss";
import FileInputField from "../common/Form/FileInput";
import "react-datepicker/dist/react-datepicker.css";
import { useSelector } from "react-redux";
import { useFormikContext } from "formik";
import { formatMoney, OnlyNumberAllow, OnlyNumberLength } from "../../helpers";
import { useLocation, useParams, useSearchParams } from "react-router-dom";
import { useEffect, useState } from "react";
import MultiSelect from "../common/Form/Multiselect";
import { AiOutlineDownload } from "react-icons/ai";
import { FiInfo } from "react-icons/fi";
import PhoneInputNumber from "../common/Form/MobileInput";
const AddApplicantform = (props) => {
  const [citiesOption, setCitiesOption] = useState([]);
  const [searchParams] = useSearchParams();
  const { setFieldValue, getFieldProps } = useFormikContext();
  const getFiled = getFieldProps();
  const params = useParams();
  const { state } = useLocation();
  const { errors, touched } = props;
  const jobProfiles = useSelector((state) => state.jobProfiles.jobData);
  const citiesData = useSelector((state) => state.jobProfiles.citiesData);
  const JobProfileChange = (e) => {
    if (e.target.value) {
      setFieldValue("jobid", e.target.value);
    }
  };
  useEffect(() => {
    if (!props.editedData && params?.jobid) {
      setFieldValue("jobid", String(params?.jobid));
    }
    setFieldValue("currLocation", props?.editedData?.currLocation);
  }, []);

  useEffect(() => {
    if (citiesData && citiesData.length > 0) {
      const resVal = citiesData.map((val) => {
        return {
          value: val,
          label: val,
        };
      });
      resVal.unshift({ value: "Remote", label: "Remote" });
      setCitiesOption(resVal);
    }
  }, [citiesData]);

  const getJobTitle = () => {
    let jobTitle = "";
    jobProfiles.map((item) => {
      if (String(item.id) === String(searchParams.get("profileId"))) {
        item.job_profile?.map((res, i) => {
          if (String(res.id) === String(params?.jobid)) {
            jobTitle = res?.jobTitle;
          }
        });
      }
    });
    return jobTitle;
  };

  return (
    <Form className={`${styles.positionForm}`} encType="multipart/form-data">
      <FormGroup className="form-group">
        <Label className={styles.formLabel}>Job Title</Label>
        <Field
          className="form-control"
          maxlength="30"
          // onInputChange={props?.editedData?.jobTitle}
          value={
            state?.jobTitle ||
            props?.editedData?.job_profile?.jobTitle ||
            getJobTitle()
          }
          name="jobTitle"
          autocomplete="off"
          placeholder="Enter Job Title"
          disabled={
            getJobTitle() ||
            state?.jobTitle ||
            props?.editedData?.job_profile?.jobTitle ||
            props?.editedData?.jobStatus === "Active" ||
            props?.editedData?.jobStatus === "Closed"
              ? true
              : false
          }
        />
        {errors?.jobTitle && touched?.jobTitle ? (
          <div className={styles?.formError}>{errors?.jobTitle}</div>
        ) : null}
      </FormGroup>
      {/* <FormGroup className="form-group">
        <Label className={styles.formLabel}>Job Title</Label>
        {props?.editedData?.job_profile ?
            <Field
            className="form-control"
            value={state?.jobTitle}
            autocomplete="off"
            disabled={props?.editedData?.job_Profile ? false : true}
         />
          :
          state && state?.jobTitle && searchParams.get("profileId")?
          <Field
          className="form-control"
          value={state?.jobTitle}
          disabled={true}
        ></Field>
          :
        <Field
          className="form-control"
          as="select"
          name="jobid"
          value={state?.jobTitle}
          disabled={true}
        >
          {state?.jobTitle}
        </Field>
        }
        {errors.jobid && touched.jobid ? (
          <div className={styles.formError}>{errors.jobid}</div>
        ) : null}
      </FormGroup> */}
      <FormGroup className="form-group">
        <Label className={styles.formLabel}>Job Profile</Label>
        {props?.editedData?.job_profile ? (
          <Field
            className="form-control"
            value={props?.editedData?.job_profile?.name}
            autocomplete="off"
            disabled={props?.editedData?.job_Profile ? false : true}
          />
        ) : params && params?.jobid && searchParams.get("profileId") ? (
          <Field
            className="form-control"
            value={
              jobProfiles &&
              jobProfiles.length > 0 &&
              jobProfiles.find(
                (item) =>
                  String(item.id) === String(searchParams.get("profileId"))
              )?.name
            }
            disabled={true}
          ></Field>
        ) : (
          <Field
            className="form-control"
            as="select"
            name="jobid"
            onChnage={(e) => {
              JobProfileChange();
            }}
            disabled={true}
          >
            <option value="" selected disabled>
              Select Profile
            </option>
            {jobProfiles &&
              jobProfiles.length > 0 &&
              jobProfiles.map((val, index) => {
                return <option value={val.id}>{val.profile_name}</option>;
              })}
          </Field>
        )}
        {errors.jobid && touched.jobid ? (
          <div className={styles.formError}>{errors.jobid}</div>
        ) : null}
      </FormGroup>
      <FormGroup className="form-group">
        <Label className={styles.formLabel}>Name</Label>
        <Field
          className="form-control"
          name="name"
          disabled={props.editedData?.name ? true : false}
          autocomplete="off"
          maxlength="20"
        />
        {errors.name && touched.name ? (
          <div className={styles.formError}>{errors.name}</div>
        ) : null}
      </FormGroup>
      <FormGroup className="form-group">
        <Label className={styles.formLabel}>Education</Label>
        <Field
          className="form-control"
          name="education"
          autocomplete="off"
          maxlength="20"
        />
        {errors.education && touched.education ? (
          <div className={styles.formError}>{errors.education}</div>
        ) : null}
      </FormGroup>
      <FormGroup className="form-group">
        <Label className={styles.formLabel}>Experience</Label>
        <Row>
          <Col md={6}>
            {/* <Label className={styles.formLabel}>Year</Label> */}
            <Field
              className="form-control"
              onKeyPress={(event) => {
                OnlyNumberLength(event);
              }}
              maxlength="2"
              name="experienceYear"
              placeholder="Year"
              autocomplete="off"
            />
          </Col>
          <Col md={6}>
            {/* <Label className={styles.formLabel}>Month</Label> */}
            <Field className="form-control" name="experienceMonth" as="select">
              <option value="" className="disableOption" selected disabled>
                Month
              </option>
              {Array.from(Array(12), (e, i) => {
                return <option value={i}>{i}</option>;
              })}
            </Field>
          </Col>
        </Row>
      </FormGroup>

      <FormGroup className="form-group">
        <Label className={styles.formLabel}>Relevant Experience</Label>
        <Row>
          <Col md={6}>
            <Field
              className="form-control"
              onKeyPress={(event) => {
                OnlyNumberLength(event);
              }}
              maxlength="2"
              name="relevantExperienceYear"
              placeholder="Year"
              autocomplete="off"
            />
          </Col>
          <Col md={6}>
            <Field
              className="form-control"
              name="relevantExperienceMonth"
              as="select"
            >
              <option value="" className="disableOption" selected disabled>
                Month
              </option>
              {Array.from(Array(12), (e, i) => {
                return <option value={i}>{i}</option>;
              })}
            </Field>
          </Col>
        </Row>
      </FormGroup>

      <FormGroup className="form-group">
        <Label className={styles.formLabel}>Current Annual CTC</Label>
        <InputGroup>
          <InputGroupText>
            <BiRupee />{" "}
          </InputGroupText>
          <Field
            className="form-control"
            onKeyPress={(event) => {
              OnlyNumberLength(event);
            }}
            maxlength="8"
            name="currentCTC"
            autocomplete="off"
          />
        </InputGroup>
      </FormGroup>
      <FormGroup className="form-group">
        <Label className={styles.formLabel}>Expected Annual CTC</Label>
        <InputGroup>
          <InputGroupText>
            <BiRupee />{" "}
          </InputGroupText>
          <Field
            className="form-control"
            onKeyPress={(event) => {
              OnlyNumberLength(event);
            }}
            maxlength="8"
            name="expectedCTC"
            autocomplete="off"
          />
        </InputGroup>
        {errors.expectedCTC && touched.expectedCTC ? (
          <div className={styles.formError}>{errors.expectedCTC}</div>
        ) : null}
      </FormGroup>
      <FormGroup className="form-group">
        <Label className={styles.formLabel}>Notice Period</Label>
        <Field className="form-control" name="noticePeriod" as="select">
          <option value="0">Immediate</option>
          <option value="0.5">15 Days</option>
          <option value="1">1 Month</option>
          <option value="2">2 Months</option>
          <option value="3">3 Months</option>
        </Field>
      </FormGroup>
      <FormGroup className="form-group">
        <Label className={styles.formLabel}>
          Resume{" "}
          <FiInfo
            className="infoIcon"
            title="Only pdf file up to 1 MB is allowed"
          />
        </Label>
        <FileInputField name="resume" />
        {props?.editedData &&
        props?.editedData?.resume?.name &&
        getFiled?.value?.resume === "" ? (
          <div className={styles.fileDisplay}>
            {" "}
            {props?.editedData?.resume?.name}{" "}
            <a
              href={props?.editedData?.resume?.url}
              download={props?.editedData?.resume?.name}
              target="_blank"
            >
              <AiOutlineDownload className={styles.downloadPart} />
            </a>
          </div>
        ) : (
          ""
        )}
        {errors.resume && touched.resume ? (
          <div className={styles.formError}>{errors.resume}</div>
        ) : null}
      </FormGroup>
      <FormGroup className="form-group">
        <Label className={styles.formLabel}>Phone</Label>
        <PhoneInputNumber
          name="phone"
          autocomplete="off"
          disabled={props.editedData?.phone ? true : false}
        />
        {errors.phone && touched.phone ? (
          <div className={styles.formError}>{errors.phone}</div>
        ) : null}
      </FormGroup>

      <FormGroup className="form-group">
        <Label className={styles.formLabel}>Email</Label>
        <Field
          className="form-control"
          name="email"
          disabled={props.editedData?.email ? true : false}
          type="email"
          autocomplete="off"
          maxlength="100"
        />
        {errors.email && touched.email ? (
          <div className={styles.formError}>{errors.email}</div>
        ) : null}
      </FormGroup>
      <FormGroup className="form-group">
        <Label className={styles.formLabel}>Preferred Location</Label>
        {citiesOption && citiesOption.length > 0 ? (
          <Field
            name="location"
            id="location"
            placeholder="Select Location"
            isMulti={false}
            component={MultiSelect}
            options={citiesOption}
            autocomplete="off"
          />
        ) : (
          <Field className="form-control" name="location" type="text" />
        )}
      </FormGroup>

      <FormGroup className="form-group">
        <Label className={styles.formLabel}>Current Location</Label>
        {citiesOption && citiesOption.length > 0 ? (
          <Field
            name="currLocation"
            id="currLocation"
            placeholder="Select Location"
            isMulti={false}
            component={MultiSelect}
            options={citiesOption}
            autocomplete="off"
          />
        ) : (
          <Field className="form-control" name="currLocation" type="text" />
        )}
      </FormGroup>

      <Button type="submit" className={styles.brandButton}>
        {props?.editedData != null ? "Update" : "Save"}
      </Button>
    </Form>
  );
};

export default AddApplicantform;
